<template>
  <b-row class="m-0 text-azul h6 col-12 col-lg-9 mx-auto">
    <b-col cols="12" class="mt-3 mt-lg-2 mb-1 mb-lg-2 text-center">
      <span class="h3 gilmer text-azul mt-2 font-weight-bold text-lg-center"
        >Recuperar Contraseña</span
      >
    </b-col>
    <b-col
      cols="12"
      class="subtitulo-cursiva text-azul text-center text-lg-center px-4 border-bottom pb-2 border-azul-claro2 border-2 gilmer mx-auto col-lg-10 col-12"
      >{{ subtitulo }}</b-col
    >
    <slot />
  </b-row>
</template>
<script>
export default {
  props: ["subtitulo"]
};
</script>



// WEBPACK FOOTER //
// src/components/generales/TituloRecuperarContrasena.vue